import { IOnInit } from "angular";
import { Machine } from "../../../../models/machine";
import { MachineConfiguration } from "../../../../models/machineConfiguration";

export class MachineDetailComponentController implements IOnInit {
  static $inject = [];
  constructor() {}

  /*bindings*/
  machine!: Machine<MachineConfiguration>;
  /*end bindings */

  currentConfiguration: MachineConfiguration | undefined;

  $onInit(): void {
    this.currentConfiguration = this.machine?.Configs?.find(
      (c) => c.CurrentConfiguration
    );
  }
}
